export default __webpack_public_path__ + "static/media/right-arrow.377a106d.svg";